export default __webpack_public_path__ + "static/yoshie2018-8df095447d061a1da108e8ea2ca8fd09.jpg";